export const generateReflinkFromCurrentPath = (refcode: string) => {
  const currentPath = window.location.href;
  const domain = currentPath.split("/")[2];
  return `https://${domain}/?ref=${refcode}`;
};
